export default "__VITE_ASSET__RgqLDPaJ__"